import * as Yup from "yup";

export const serviceValidationSchema = Yup.object({
  name: Yup.string().required("Service name is required")
    .min(3,`Service name should be at least 3 characters`)
    .max(50, "Service name can't exceed 50 characters"),
  description: Yup.string()
    .min(3, "Description should be at least 3 characters")
    .max(300, "Description can't exceed 300 characters"),
  code: Yup.string().required("Service code is required")
    .min(1, `Service code should be at least 1 characters`),
  category: Yup.array().min(1, "At least one category must be added or selected"),
    minPrice: Yup.number()
      .typeError('Minimum price must be a number')
      .required('Minimum price is required')
      .min(0, 'Minimum price cannot be negative')
      .max(999999, "Minimum price can't exceed 999999")
      .test(
        "is-decimal",
        "Min price can have up to two decimal places",
        value => value === undefined || /^\d+(\.\d{1,2})?$/.test(value.toString())
      ),
    maxPrice: Yup.number()
      .typeError('Maximum price must be a number')
      .required('Maximum price is required')
      .min(Yup.ref('minPrice'), 'Max price should be greater than min price')
      .max(999999, "Maximum price can't exceed 999999")
      .test(
        "is-decimal",
        "Max price can have up to two decimal places",
        value => value === undefined || /^\d+(\.\d{1,2})?$/.test(value.toString())
      ),
  subServices: Yup.array().of(
    Yup.object({
      name: Yup.string().required(),
      minPrice: Yup.number()
        .typeError('Minimum price must be a number')
        .required('Minimum price is required')
        .min(0, 'Minimum price cannot be negative')
        .max(999999, "Minimum price can't exceed 999999")
        .test('max-digits', 'Price can have up to 6 digits before decimal and 2 after', value => {
          if (value === undefined || value === null) return true;
          const [int, dec] = value.toString().split('.');
          return int.length <= 6 && (!dec || dec.length <= 2);
        }),
      maxPrice: Yup.number()
        .typeError('Maximum price must be a number')
        .required('Maximum price is required')
        .min(Yup.ref('minPrice'), 'Max price should be greater than min price')
        .max(999999, "Maximum price can't exceed 999999")
        .test('max-digits', 'Price can have up to 6 digits before decimal and 2 after', value => {
          if (value === undefined || value === null) return true;
          const [int, dec] = value.toString().split('.');
          return int.length <= 6 && (!dec || dec.length <= 2);
        }),
    })
  ),
  commissionPercent: Yup.number().min(0).max(100, "Commission percent can't exceed 100"),
  commissionValue: Yup.number()
    .typeError('Commission value must be a number')
    .positive("Commission value must be positive")
    .min(0)
    .max(999999, "Commission value can't exceed 999999")
    .test(
      "is-decimal",
      "Commission value can have up to two decimal places",
      value => value === undefined || /^\d+(\.\d{1,2})?$/.test(value.toString())
    )
  
});
